import { render, staticRenderFns } from "./Sider.vue?vue&type=template&id=5539306a&scoped=true&"
import script from "./Sider.vue?vue&type=script&lang=js&"
export * from "./Sider.vue?vue&type=script&lang=js&"
import style0 from "./Sider.vue?vue&type=style&index=0&id=5539306a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539306a",
  null
  
)

export default component.exports